import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getEmployees } from "../../../lib/getEmployees";
import AllEmployeeTable from "./AllEmployeeTable";

const AllEmployees = () => {
  debugger
  const [employeeList, setEmployeeList] = useState([]);
  const navigate = useNavigate();

  // Memorize the value of `storage` to avoid multiple localStorage reads.
  const storage = useMemo(() => {
    return JSON.parse(window.localStorage.getItem("userDetails"));
  }, []);

  // Función para refrescar la lista de empleados
  const refreshEmployeeList = useCallback(() => {
    getEmployees().then((res) => {
      console.log("DATA1111", res.data);
      if (Array.isArray(res.data)) {
        debugger
        // Solo actualizamos el estado si los datos son distintos
        if (JSON.stringify(employeeList) !== JSON.stringify(res.data)) {
          setEmployeeList(res.data);
        }
      } else {
        setEmployeeList([]); // Inicializa como array vacío si no es un array
      }
    });
    // eslint-disable-next-line
  }, [employeeList]);

  useEffect(() => {
    if (storage?.role === "superadmin") {
      debugger
      refreshEmployeeList();
    } else {
      navigate("/");
    }
    // Evitamos que `employeeList` sea una dependencia aquí para evitar el ciclo infinito
    // eslint-disable-next-line
  }, [navigate, storage, refreshEmployeeList]);

  return (
    <>
      <h2>Listado de Empleados</h2>
      <AllEmployeeTable
        data={employeeList}
        setEmployeeList={setEmployeeList}
        refreshEmployeeList={refreshEmployeeList} // Pasamos la función para refrescar la lista
      />
    </>
  );
};

export default AllEmployees;
